<div class="synonym-container">
    <!-- Header -->
    <div class="synonym-header">
        <div class="header-content">
            <div class="title-section">
                <h1>Sinónimos</h1>
                <p class="subtitle">Gestiona grupos de términos equivalentes para mejorar la búsqueda de productos</p>
            </div>
            <button class="btn-primary" (click)="openCreateModal()">
                <mat-icon>add</mat-icon>
                <span>Nuevo Grupo</span>
            </button>
        </div>

        <!-- Search Bar -->
        <div class="search-section">
            <div class="search-input-wrapper">
                <mat-icon class="search-icon">search</mat-icon>
                <input 
                    type="text" 
                    placeholder="Buscar grupos por nombre..."
                    [value]="searchQuery"
                    (input)="onSearch($any($event.target).value)"
                    class="search-input"
                />
                <button *ngIf="searchQuery" class="clear-btn" (click)="clearSearch()">
                    <mat-icon>close</mat-icon>
                </button>
            </div>
            <div class="results-count" *ngIf="!isLoading">
                {{ dataItems.total || 0 }} grupo{{ dataItems.total !== 1 ? 's' : '' }} encontrado{{ dataItems.total !== 1 ? 's' : '' }}
            </div>
        </div>
    </div>

    <!-- Loading State -->
    <div class="loading-container" *ngIf="isLoading">
        <mat-spinner diameter="48"></mat-spinner>
        <p>Cargando grupos...</p>
    </div>

    <!-- Empty State -->
    <div class="empty-state" *ngIf="!isLoading && (!dataItems.data || dataItems.data.length === 0)">
        <mat-icon class="empty-icon">library_books</mat-icon>
        <h3 *ngIf="!searchQuery">No hay grupos de sinónimos</h3>
        <h3 *ngIf="searchQuery">No se encontraron resultados para "{{ searchQuery }}"</h3>
        <p *ngIf="!searchQuery">Crea tu primer grupo para mejorar los resultados de búsqueda</p>
        <p *ngIf="searchQuery">Intenta con otros términos de búsqueda</p>
        <button class="btn-primary" (click)="searchQuery ? clearSearch() : openCreateModal()">
            <mat-icon>{{ searchQuery ? 'refresh' : 'add' }}</mat-icon>
            <span>{{ searchQuery ? 'Limpiar búsqueda' : 'Crear Grupo' }}</span>
        </button>
    </div>

    <!-- Cards Grid -->
    <div class="cards-grid" *ngIf="!isLoading && dataItems.data && dataItems.data.length > 0">
        <div 
            class="group-card" 
            *ngFor="let group of dataItems.data"
            [class.expanded]="isExpanded(group)"
            [class.inactive]="group.is_active === 0"
        >
            <!-- Card Header -->
            <div class="card-header" (click)="toggleExpand(group)">
                <div class="card-title-section">
                    <h3 class="card-title">{{ group.group_name }}</h3>
                    <div class="card-meta">
                        <span class="synonym-count">
                            <mat-icon>label</mat-icon>
                            {{ getSynonymCount(group) }} sinónimo{{ getSynonymCount(group) !== 1 ? 's' : '' }}
                        </span>
                    </div>
                </div>
                <div class="card-actions">
                    <button 
                        class="status-toggle"
                        [class.active]="group.is_active === 1"
                        (click)="toggleStatus(group, $event)"
                        [matTooltip]="group.is_active === 1 ? 'Activo - Click para desactivar' : 'Inactivo - Click para activar'"
                    >
                        <span class="toggle-track">
                            <span class="toggle-thumb"></span>
                        </span>
                        <span class="status-label">{{ group.is_active === 1 ? 'Activo' : 'Inactivo' }}</span>
                    </button>
                    <button class="icon-btn edit" (click)="openEditModal(group, $event)" matTooltip="Editar grupo">
                        <mat-icon>edit</mat-icon>
                    </button>
                    <button class="icon-btn delete" (click)="openDeleteModal(group, $event)" matTooltip="Eliminar grupo">
                        <mat-icon>delete</mat-icon>
                    </button>
                    <button class="icon-btn expand" [class.rotated]="isExpanded(group)">
                        <mat-icon>expand_more</mat-icon>
                    </button>
                </div>
            </div>

            <!-- Card Body (Synonyms) -->
            <div class="card-body" *ngIf="isExpanded(group)">
                <!-- Synonyms List -->
                <div class="synonyms-section">
                    <div class="synonyms-header">
                        <span class="section-label">Sinónimos del grupo</span>
                    </div>
                    
                    <div class="synonyms-list" *ngIf="group.synonyms && group.synonyms.length > 0">
                        <div class="synonym-chip" *ngFor="let synonym of group.synonyms">
                            <span class="synonym-text">{{ synonym.synonym_phrase }}</span>
                            <span class="word-count" *ngIf="synonym.word_count > 1">
                                {{ synonym.word_count }} palabras
                            </span>
                            <button class="remove-btn" (click)="removeSynonym(group, synonym, $event)" matTooltip="Eliminar">
                                <mat-icon>close</mat-icon>
                            </button>
                        </div>
                    </div>

                    <div class="no-synonyms" *ngIf="!group.synonyms || group.synonyms.length === 0">
                        <mat-icon>info_outline</mat-icon>
                        <span>No hay sinónimos en este grupo. Agrega algunos para activar la búsqueda expandida.</span>
                    </div>

                    <!-- Add Synonym Input -->
                    <div class="add-synonym-form">
                        <div class="input-wrapper">
                            <input 
                                type="text"
                                placeholder="Ej: televisor, smart tv, led..."
                                [(ngModel)]="newSynonymPhrase[group.id]"
                                (keydown.enter)="addSynonym(group)"
                                [disabled]="addingSynonym[group.id]"
                                class="synonym-input"
                            />
                            <button 
                                class="add-btn"
                                (click)="addSynonym(group)"
                                [disabled]="addingSynonym[group.id] || !newSynonymPhrase[group.id]?.trim()"
                            >
                                <mat-icon *ngIf="!addingSynonym[group.id]">add</mat-icon>
                                <mat-spinner *ngIf="addingSynonym[group.id]" diameter="20"></mat-spinner>
                                <span>Agregar</span>
                            </button>
                        </div>
                        <p class="input-hint">Presiona Enter o click en Agregar. Las frases con múltiples palabras están soportadas.</p>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <!-- Pagination -->
    <div class="pagination" *ngIf="!isLoading && dataItems.data && dataItems.data.length > 0 && totalPages > 1">
        <button 
            class="page-btn" 
            [disabled]="currentPage === 1"
            (click)="onPageChange(1)"
        >
            <mat-icon>first_page</mat-icon>
        </button>
        <button 
            class="page-btn" 
            [disabled]="currentPage === 1"
            (click)="onPageChange(currentPage - 1)"
        >
            <mat-icon>chevron_left</mat-icon>
        </button>
        
        <button 
            *ngFor="let page of pages"
            class="page-btn page-number"
            [class.active]="page === currentPage"
            (click)="onPageChange(page)"
        >
            {{ page }}
        </button>
        
        <button 
            class="page-btn" 
            [disabled]="currentPage === totalPages"
            (click)="onPageChange(currentPage + 1)"
        >
            <mat-icon>chevron_right</mat-icon>
        </button>
        <button 
            class="page-btn" 
            [disabled]="currentPage === totalPages"
            (click)="onPageChange(totalPages)"
        >
            <mat-icon>last_page</mat-icon>
        </button>
    </div>
</div>

<!-- Create Modal -->
<div class="modal-overlay" *ngIf="showCreateModal" (click)="closeCreateModal()">
    <div class="modal-content" (click)="$event.stopPropagation()">
        <div class="modal-header">
            <h2>Crear nuevo grupo</h2>
            <button class="close-btn" (click)="closeCreateModal()">
                <mat-icon>close</mat-icon>
            </button>
        </div>
        <div class="modal-body">
            <div class="form-group">
                <label for="groupName">Nombre del grupo</label>
                <input 
                    id="groupName"
                    type="text" 
                    placeholder="Ej: Televisores, Refrigeradores..."
                    [(ngModel)]="newGroupName"
                    (keydown.enter)="createGroup()"
                    class="form-input"
                />
                <p class="form-hint">Nombre descriptivo para identificar este grupo de sinónimos</p>
            </div>
            <div class="form-group">
                <label>Estado</label>
                <div class="status-options">
                    <button 
                        class="status-option"
                        [class.selected]="newGroupIsActive === 1"
                        (click)="newGroupIsActive = 1"
                    >
                        <mat-icon>check_circle</mat-icon>
                        <span>Activo</span>
                    </button>
                    <button 
                        class="status-option"
                        [class.selected]="newGroupIsActive === 0"
                        (click)="newGroupIsActive = 0"
                    >
                        <mat-icon>pause_circle</mat-icon>
                        <span>Inactivo</span>
                    </button>
                </div>
                <p class="form-hint">Los grupos activos se usan para expandir búsquedas</p>
            </div>
        </div>
        <div class="modal-footer">
            <button class="btn-secondary" (click)="closeCreateModal()" [disabled]="isSaving">
                Cancelar
            </button>
            <button class="btn-primary" (click)="createGroup()" [disabled]="isSaving || !newGroupName.trim()">
                <mat-spinner *ngIf="isSaving" diameter="18"></mat-spinner>
                <span>{{ isSaving ? 'Creando...' : 'Crear grupo' }}</span>
            </button>
        </div>
    </div>
</div>

<!-- Edit Modal -->
<div class="modal-overlay" *ngIf="showEditModal" (click)="closeEditModal()">
    <div class="modal-content" (click)="$event.stopPropagation()">
        <div class="modal-header">
            <h2>Editar grupo</h2>
            <button class="close-btn" (click)="closeEditModal()">
                <mat-icon>close</mat-icon>
            </button>
        </div>
        <div class="modal-body" *ngIf="editingGroup">
            <div class="form-group">
                <label for="editGroupName">Nombre del grupo</label>
                <input 
                    id="editGroupName"
                    type="text" 
                    placeholder="Ej: Televisores, Refrigeradores..."
                    [(ngModel)]="editingGroup.group_name"
                    (keydown.enter)="updateGroup()"
                    class="form-input"
                />
            </div>
            <div class="form-group">
                <label>Estado</label>
                <div class="status-options">
                    <button 
                        class="status-option"
                        [class.selected]="editingGroup.is_active === 1"
                        (click)="editingGroup.is_active = 1"
                    >
                        <mat-icon>check_circle</mat-icon>
                        <span>Activo</span>
                    </button>
                    <button 
                        class="status-option"
                        [class.selected]="editingGroup.is_active === 0"
                        (click)="editingGroup.is_active = 0"
                    >
                        <mat-icon>pause_circle</mat-icon>
                        <span>Inactivo</span>
                    </button>
                </div>
            </div>
        </div>
        <div class="modal-footer">
            <button class="btn-secondary" (click)="closeEditModal()" [disabled]="isSaving">
                Cancelar
            </button>
            <button class="btn-primary" (click)="updateGroup()" [disabled]="isSaving || !editingGroup?.group_name?.trim()">
                <mat-spinner *ngIf="isSaving" diameter="18"></mat-spinner>
                <span>{{ isSaving ? 'Guardando...' : 'Guardar cambios' }}</span>
            </button>
        </div>
    </div>
</div>

<!-- Delete Confirmation Modal -->
<div class="modal-overlay" *ngIf="showDeleteModal" (click)="closeDeleteModal()">
    <div class="modal-content modal-delete" (click)="$event.stopPropagation()">
        <div class="modal-header">
            <h2>¿Eliminar grupo?</h2>
            <button class="close-btn" (click)="closeDeleteModal()">
                <mat-icon>close</mat-icon>
            </button>
        </div>
        <div class="modal-body" *ngIf="deletingGroup">
            <div class="delete-warning">
                <mat-icon class="warning-icon">warning</mat-icon>
                <div class="warning-content">
                    <p class="warning-title">Esta acción no se puede deshacer</p>
                    <p class="warning-message">
                        Se eliminará permanentemente el grupo "<strong>{{ deletingGroup.group_name }}</strong>" 
                        y todos sus <strong>{{ getSynonymCount(deletingGroup) }} sinónimo{{ getSynonymCount(deletingGroup) !== 1 ? 's' : '' }}</strong>.
                    </p>
                </div>
            </div>
            <div class="tip-box">
                <mat-icon>lightbulb</mat-icon>
                <span>Si solo quieres desactivar el grupo temporalmente, usa el toggle de estado en vez de eliminar.</span>
            </div>
        </div>
        <div class="modal-footer">
            <button class="btn-secondary" (click)="closeDeleteModal()" [disabled]="isSaving">
                Cancelar
            </button>
            <button class="btn-danger" (click)="confirmDeleteGroup()" [disabled]="isSaving">
                <mat-spinner *ngIf="isSaving" diameter="18"></mat-spinner>
                <mat-icon *ngIf="!isSaving">delete</mat-icon>
                <span>{{ isSaving ? 'Eliminando...' : 'Eliminar grupo' }}</span>
            </button>
        </div>
    </div>
</div>
